const DASHBOARD_EVENTS = {
  STATUS_UPDATE: 'dashboard:status-update',
};

export default DASHBOARD_EVENTS;
